// 保存当前业务id的 localstorage

const key = "businessId";
export function setBusinessId(val) {
    val && localStorage.setItem(key, val);
}
export function getBusinessId() {
    const val = localStorage.getItem(key);

    return val == null ? val : parseInt(val);
}
